import React from 'react';
import Hero from '../components/Hero';
import Why from '../components/Why';
import About from '../components/About';
import Services from '../components/Services';
import CTA from '../components/CTA';

function Home() {
  return (
    <>
      <Hero />
      <Why />
      <About />
      <Services />
      <CTA />
    </>
  );
}

export default Home;
